import { render } from "./InvitoAutolettura.vue?vue&type=template&id=3cf4b4f6&scoped=true"
import script from "./InvitoAutolettura.vue?vue&type=script&lang=js"
export * from "./InvitoAutolettura.vue?vue&type=script&lang=js"

import "./InvitoAutolettura.vue?vue&type=style&index=0&id=3cf4b4f6&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf4b4f6"]])

export default __exports__